"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPageCount = void 0;
const typeguard_1 = require("../types/typeguard");
const pageCountRuleSet = {
  min: typeguard_1.isNumber,
  max: typeguard_1.isNumber
};
const isPageCount = pc => (0, typeguard_1.isType)(pc, pageCountRuleSet);
exports.isPageCount = isPageCount;